module.exports = __webpack_public_path__ + "img/师父.4841d3a1.png";